import { Config } from '../_config'
import { QueryParams } from './QueryParams'

export class WindowQueryParams extends QueryParams {
  static create({ config }: { config: Config }) {
    return new WindowQueryParams(config)
  }

  constructor(private config: Config) {
    super()
  }

  searchParams(): URLSearchParams {
    return new URLSearchParams(window.location.search)
  }
}
